"use client";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Error } from "../error/error";
import { useTranslations } from "next-intl";

type Props = {
  label: string;
  className?: string;
  containerClassName?: string;
  wrapperClassName?: string;
  labelClassName?: string;
  error?: string;
  resize?: string;
};

const Textarea: React.FC<
  Props & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = ({
  label,
  placeholder,
  onChange,
  name,
  value,
  id,
  containerClassName,
  wrapperClassName,
  className,
  labelClassName,
  error,
  resize,
}) => {
  const t = useTranslations();

  const [textAreaValue, setTextAreaValue] = useState(value);

  useEffect(() => {
    setTextAreaValue(value);
  }, [value]);

  return (
    <div className={classNames("relative w-full", containerClassName)}>
      <div className={classNames("input-wrapper w-full", wrapperClassName)}>
        <textarea
          className={classNames(
            "input-field w-full rounded-[26px] border !bg-[#f1f6f7] p-8 text-xs font-normal leading-tight focus:outline-none",
            resize || "resize-none",
            className,
            {
              // error
              "border-red-600": !!error,
              // active
              "border-transparent active:border-[#cfe0e2]": !error,
            },
          )}
          placeholder={placeholder}
          onChange={(e) => {
            setTextAreaValue(e.target.value);
            if (onChange) onChange(e);
          }}
          id={id}
          name={name}
          value={textAreaValue}
        />
        <label
          className={classNames(
            "input-label leading-tight",
            labelClassName,
            !!error && "text-red-600 !opacity-100",
          )}
          htmlFor={id}
        >
          {t(label)}
        </label>
      </div>
      {error && typeof error === "string" && <Error text={error} />}
    </div>
  );
};

export { Textarea };
